export const LOCAL_STORAGE_USER_TOKEN = "token";
export const LOCAL_STORAGE_USER  = "user";
export const LOCAL_STORAGE_ROLES  = "roles";

